import React from 'react';
import {Styles} from '../../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button/Button";
import {Translate} from "../../../../../../config/Translate";
import { withSnackbar } from 'notistack';
import withWidth from "@material-ui/core/withWidth/withWidth";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import IconButton from "@material-ui/core/IconButton/IconButton";
import CloseIcon from '@material-ui/icons/Close';
import RoomRoundedIcon from '@material-ui/icons/RoomRounded';
import axios from "axios";
import {defaultVariabls} from "../../../../../../config";
import {updateRedux} from "../../../../../../config/Security";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import LoadingButton from "../../../../../components/elements/LoadingButton";
import {getName} from "../../../../../../config/values";
import moment from "jalali-moment";
class ProposalSubmissionButton extends React.Component {
    state = {
        open:false,
        person:this.props.person,
        fields: {
            name:getName(this.props.person),
            manager:'مدیر فنی رایانیتا، مهندس فراهانی',
            time:moment().add(1,'days').locale('fa').format( 'D MMM'),
            SubmitLoading:false,
        },
    };
    handleChange(e){
        let {fields} = this.state;
        let target = e.target;
        fields[target.name] = target.value;
        this.setState({
            fields,
        });
    }
    handleValidation(callback){
        let { fields,province,city } = this.state;
        let errors = {};
        let formIsValid = true;

        if(!formIsValid){
            this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                variant: 'warning',
            });
            this.setState({
                SubmitLoading:false,
                errors
            })
        }
        return callback(formIsValid)
    }
    handleRequest(){
        const {fields,person} = this.state;
        let data = new FormData();
        data.append('name', fields.name);
        data.append('manager', fields.manager);
        data.append('time', fields.time);
        data.append('person_id', person.id);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/send-sms/meeting-announcement`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.smsSent, {
                    variant: 'success',
                });
                this.setState({
                    open:false,
                    SubmitLoading:false
                })

            })
            .catch(error => {
                console.log(error.response)
                this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                    variant: 'error',
                });
                this.setState({
                    SubmitLoading:false
                });
            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }

        });
    }
    render(){
        let {open,fields,person,SubmitLoading} = this.state;
        return(
            <>
                <Button
                    color="primary"
                    size="small"
                    variant="contained"
                    onClick={() => this.setState({open: !this.state.open})}
                    style={{marginLeft:5,marginRight:5}}
                >
                    {Translate.meetingAnnoucement}
                </Button>
                <Dialog  fullWidth maxWidth="sm"  open={open} onClose={() => this.setState({open: !this.state.open})} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">
                        {Translate.meetingAnnoucement}
                        <IconButton aria-label="close" className="modal-close-btn"  onClick={() => this.setState({open: !this.state.open})}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    value={fields.name}
                                    fullWidth
                                    label={Translate.userName}
                                    name="name"
                                    onChange={this.handleChange.bind(this)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    value={fields.manager}
                                    fullWidth
                                    label={Translate.meeter}
                                    name="manager"
                                    onChange={this.handleChange.bind(this)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    value={fields.time}
                                    fullWidth
                                    label={Translate.time}
                                    name="time"
                                    onChange={this.handleChange.bind(this)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    onClick = {this.handleSubmit.bind(this)}
                                    loading = {SubmitLoading}
                                >
                                    {Translate.sendSMS}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
            </>
        )
    }
}

export default withWidth()(withSnackbar(withStyles(Styles)(ProposalSubmissionButton)));